module.exports = __webpack_public_path__ + "e9c477e8/img/document.e2130c6b.svg";